export default __webpack_public_path__ + "static/media/card_logo.9798bd99.svg";